import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useState } from 'react';
import styled from 'styled-components/macro';

interface Props {
    className?: string;
    link: string;
}

export const DialogOpenEventView = (props: Props): JSX.Element => {
    const [showDialog] = useState(true);

    function onOpen() {
        window.open(props.link, '_blank');
    }

    // function onClose() {
    //     setShowDialog(false);
    // }

    if (!showDialog) {
        return null;
    }

    return (
        <S_DialogOpenEventView className={props.className}>
            <S_Inner onClick={onOpen}>
                <S_Open icon={['far', 'arrow-up-right-from-square']} />
                <S_Text>Åpne i en app</S_Text>
                {/* <S_Close onClick={onClose} icon={['fal', 'xmark']} /> */}
            </S_Inner>
        </S_DialogOpenEventView>
    );
};

const S_DialogOpenEventView = styled.div`
    width: 100%;
`;

const S_Inner = styled.div`
    position: absolute;
    z-index: 999;
    display: flex;
    padding: 20px;
    user-select: none;
    background-color: #333333;
    color: white;
    border-bottom: 1px solid #e0e0e0;
    border-radius: 15px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: flex-start;
    align-items: center;
    gap: 20px;
    width: fit-content;
    cursor: pointer;
    &:hover {
        background-color: #050505;
    }
    top: 10px;
    left: 10px;
    right: 0px;
    bottom: unset;
    @media only screen and (min-width: 1260px) {
        top: 100px;
        left: 25px;
    }
`;

const S_Text = styled.div``;

const S_Open = styled(FontAwesomeIcon)``;

// const S_Close = styled(FontAwesomeIcon)`
//     top: 10px;
//     right: 15px;
//     position: absolute;
//     padding: 10px;
//     width: 14px;
//     height: 14px;
//     border-radius: 50%;
//     cursor: pointer;
//     display: flex;
//     justify-content: center;
//     align-items: center;
//     font-size: 12px;
//     background: #000;
//     color: #fff;
// `;
